/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Educational Material Container
 */

// Dependencies
import React from 'react';
// import PropTypes from 'prop-types';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * EducationalMaterial Container.
 * @return { Node } React Educational Material container.
 */
const EducationalMaterialContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name EducationalMaterial.propTypes
 * @type { Object }
 */
EducationalMaterialContainer.propTypes = {};

/**
 * Default props
 */
EducationalMaterialContainer.defaultProps = {};

export default EducationalMaterialContainer;
